import React from "react";

function Footer() {
  return (
    <footer>
      <div className="wrap">
        <div className="flex">
          <a href="/"><img src="/image/ft_logo.png" alt="" /></a>
          <div className="content">
            <p>주소 ㅣ 대구광역시 중구 달구벌대로 1988-3, 5층</p>
            <p>전화 ㅣ 053-252-0808 <span></span> 대표자 ㅣ 이권수</p>
            <p>사업자등록번호 ㅣ 445-62-00536</p>
          </div>
          <nav>
            {/* <p>개인정보 취급방침 ㅣ 이용약관</p> */}
            <span>ⓒurocure.co.kr All Right Reserved.</span>
          </nav>
        </div>
      </div>
    </footer>
  )
}

export default Footer;